export default {"src":"/_next/static/media/logo.3c321739.svg","height":110,"width":110,"blurWidth":0,"blurHeight":0};